<ion-content>
  <ion-datetime
    #datetime
    [value]="initialValue"
    [presentation]="withTime ? 'date-time' : 'date'"
    [locale]="locale"
    firstDayOfWeek="1"></ion-datetime>
</ion-content>
<div class="footer">
  <ion-button data-testid="ok-btn" (click)="ok(datetime.value)" [disabled]="!datetime.value">
    {{ 'm/ok' | translate }}
  </ion-button>
  <ion-button data-testid="cancel-btn" (click)="cancel()" fill="outline">
    {{ 'm/cancel' | translate }}
  </ion-button>
</div>
